<template>
  <form-field
    :label="label"
    :validation-errors="validationErrors"
    :label-for="forId"
    :help-text="helpText"
  >
    <!-- https://buefy.org/documentation/taginput  -->
    <b-taginput
      v-bind="$attrs"
      :id="forId"
      :value="value"
      :icon="icon"
      :placeholder="placeholder"
      @input="handleInput"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"

      autocomplete
      :data="filteredOptions"
      :allow-new="allowNew"
      :open-on-focus="openFocus"
      :field="field"
      :size="size"
      :type="type"
      @typing="filterOptions"
      expanded
    ></b-taginput>
  </form-field>
</template>

<script>
import FormField from "./FormField";
import {FormFieldMixin} from "./FormField.mixin";

export default {
  name: "FormFieldCollection",
  components: {FormField},
  mixins: [FormFieldMixin],
  props: {
    value: {},
    placeholder: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
    },
    validationErrors: {
      type: [String, Array, undefined],
    },
    helpText: {
      type: String,
    },
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'is-small'
    },
    allowNew: {
      type: Boolean,
      default: false,
    },
    openFocus: {
      type: Boolean,
      default: true,
    },
    // Required if you are doing more then an array of strings for your options
    options: {
      type: Array,
      default:  function () {
        return []
      },
      required: false,
    },
    // Required if you are doing more then an array of strings for your options
    field: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      forId: this.$utils.generateClientId(),
      search: '',
    }
  },
  computed: {
    filteredOptions() {
      const selectedValues = this.value.map(val => val.id)
      const newOptions = this.options.filter(option => ! selectedValues.includes(option.id))

      if (this.search) {
        return newOptions.filter((option) => {
          return option[this.field]
            .toString()
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) >= 0
        })
      }

      return newOptions
    },
  },
  methods: {
    filterOptions(text) {
      this.search = text
    },
    handleInput(val) {
      this.$emit('input', val);
      this.$emit('change', val);
      this.$emit('selected', val);

      // if search has value then reset it after selecting an option
      this.search = ''

      this.emitGlobalFieldChangeEvent();
    },
  }
}
</script>

<style lang="scss">
.taginput {
  width: 100%;

  &-container.is-focusable {
    padding-right: 1px !important;
  }
}
</style>
